import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class CallForwardRepository extends CrudRepository {
  constructor () {
    super('core/api/callForward/')
  }

  async activate (item) {
    const data = await Repository.post(`${this.resource}activate`, item)
    return data
  }

  async show (item) {
    const data = await Repository.post(`${this.resource}show`, item)
    return data
  }
}
